import React, { useState } from 'react'
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Modal, Box, IconButton, TextField, FormControl, Tooltip, Select, MenuItem, Grid } from '@mui/material';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import TeamSelectDroupDown from '../../../../components/Projects/project-components/TeamSelectDroupDown';
import MultiClientSelect from '../../../../components/DemoTabs/MultiClientSelect';
import CheckBoxSec from '../../../../pages/Settings/General-Settings/CheckBoxSec';
const PolicyPopup = ({ openPolicyPop, handleClosePolicyPop }) => {
    const modalMoveActivities = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '586px',
        width: '90%',
        margin: 'auto',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: '2px',
        // border: '2px solid #0B57D0'
        border: '2px solid transparent',
        backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
        backgroundOrigin: 'border-box',
        backgroundClip: 'content-box, border-box',
        borderRadius: '12px',
    };

    const [scheduleDropDown, setScheduleDropDown] = useState('')
    const [scheduleDropDownNegative, setScheduleDropDownNegative] = useState('')
    const [scheduleDropDownApprovals, setScheduleDropDownApprovals] = useState('')
    const [scheduleDropDownRoolsAnnual, setScheduleDropDownRoolsAnnual] = useState('')
    const [scheduleDropDownPaid, setScheduleDropDownPaid] = useState('')
    const [selectedTeamsAll, setSelectedTeamsAll] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const dropDownCssLabel = [
        {
            height: '40px', padding: '12px 2px', margin: '4px 0'
        }
    ]
    const accuralData = [
        {
            option: 'Annual',
            label: ' Hours are accrued when the member joins the policy, and on January 1st of every year'
        },
        {
            option: 'Hours worked',
            label: '  Hours are accrued when time worked is marked as paid'
        },
        {
            option: 'Policy joined date',
            label: '  Hours are accrued when the member is added to the policy, at a prorated amount for the year. Hours are also accrued on January 1st of every year.'
        },
        {
            option: 'None',
            label: 'Time off will not be automatically accrued for this policy'
        },
    ]

    const negativeBalance = [
        {
            option: 'Yes',
            label: 'Members may request time off even if it lowers their balance below 0'
        },
        {
            option: 'No',
            label: 'Members cannot request time off if it will bring their balance below 0'
        },
    ]
    const requireApprovals = [
        {
            option: 'Yes',
            label: 'Requests must be manually approved by a manager or team lead    '
        },
        {
            option: 'No',
            label: 'Requests are automatically approved and applied without a managers approval'
        },
    ]
    const annuallyBalance = [
        {
            option: 'Yes',
            label: 'Any remaining balance will be kept on January 1st'
        },
        {
            option: 'No',
            label: 'Any remaining time off will be removed on January 1st'
        },
    ]
    const paidUnpaidData = [
        {
            option: 'Yes',
            label: 'Time in approved requests will be counted towards amounts owed'
        },
        {
            option: 'No',
            label: 'Hours in approved time off requests will not count towards amounts owed'
        },
    ]
    const users = [
        { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: 'Alice Smith', image: null },
        { name: 'Mike Johnson', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
        { name: 'Mike2 Johnson', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: 'Mike3 Johnson', image: 'https://randomuser.me/api/portraits/men/4.jpg' },
        { name: 'Mike4 Johnson', image: 'https://randomuser.me/api/portraits/men/5.jpg' },
    ];

    return (
        <>

            <Modal open={openPolicyPop} fullWidth maxWidth="sm">
                <Box sx={{
                    ...modalMoveActivities,
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '90vh',
                    overflow: 'hidden',
                }}>
                    {/* Header */}
                    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                        <Box>
                            <Typography variant="h6" fontSize={'17px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Add time off Policy</Typography>
                        </Box>
                        <IconButton onClick={handleClosePolicyPop} className='p-0'>
                            <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                        </IconButton>
                    </Box>
                    {/* End Header */}

                    {/* start Body sec  */}
                    <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                        <Box sx={{ marginBottom: '20px' }}>
                            <Box sx={{ m: '0 auto 24px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <Box>
                                    <GppGoodOutlinedIcon sx={{ color: '#0076FE' }} />
                                </Box>
                                <Box sx={{ marginTop: '4px' }}>
                                    <Typography sx={{ color: '#0076FE', fontSize: '15px', fontWeight: '600' }}>
                                        Set up policy
                                    </Typography>
                                </Box>
                            </Box>
                            <Grid container spacing={1}>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>Policy Name</Typography>
                                        <TextField placeholder="Enter a name for the policy" fullWidth size="small" fontWeight={400}
                                            sx={{ borderRadius: '6px', margin: '4px auto', fontSize: '14px', fontFamily: 'Manrope' }} />
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>Schedule of accrual <Tooltip title="This allows managers to set up policies." arrow placement="top" alignContent="center">
                                            <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                                <InfoOutlineIcon fontSize="small" />
                                            </button>
                                        </Tooltip></Typography>

                                        <FormControl fullWidth>
                                            <Select
                                                sx={dropDownCssLabel}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={scheduleDropDown}
                                                onChange={(e => setScheduleDropDown(e.target.value))}
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    if (!selected) {
                                                        return <Typography sx={{ color: '#9e9e9e' }}>Select accrual type</Typography>;
                                                    }
                                                    return <Typography sx={{ fontSize: '14px', fontWeight: '500' }}>{selected}</Typography>;
                                                }}
                                            >
                                                {
                                                    accuralData.map((curElem => (
                                                        <MenuItem value={curElem.option} key={curElem.option}>
                                                            <Box>
                                                                <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>{curElem.option}</Typography>
                                                                <Typography variant="body2" sx={{ fontSize: '14px', color: '#595959', fontWeight: '400', fontFamily: 'Manrope' }} color="text.secondary">
                                                                    {curElem.label}
                                                                </Typography>
                                                            </Box>
                                                        </MenuItem>
                                                    )))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Box sx={{ m: '0 auto 5px', width: '100%' }}>
                                            <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>Maximum Accrual Amount</Typography>
                                            <TextField placeholder="Maximum Accrual Amount" fullWidth size="small" fontWeight={400}
                                                sx={{ borderRadius: '6px', margin: '4px auto', fontSize: '14px', fontFamily: 'Manrope' }} />
                                        </Box>
                                        <Box sx={{ width: '100px', fontSize: '14px', color: '#1A1F36', marginTop: '10px' }}>
                                            Hrs per year
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 6, md: 6, lg: 6, xl: 6 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Box sx={{ m: '0 auto 5px', width: '100%' }}>
                                            <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>Allow Negative Balancers</Typography>
                                            <FormControl fullWidth>
                                                <Select
                                                    sx={dropDownCssLabel}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={scheduleDropDownNegative}
                                                    onChange={(e => setScheduleDropDownNegative(e.target.value))}
                                                    displayEmpty
                                                    renderValue={(selected) => {
                                                        if (!selected) {
                                                            return <Typography sx={{ color: '#9e9e9e' }}>Select Negative Balancers </Typography>;
                                                        }
                                                        return <Typography sx={{ fontSize: '14px', fontWeight: '500' }}>{selected}</Typography>;
                                                    }}
                                                >
                                                    {
                                                        negativeBalance.map((curElem => (
                                                            <MenuItem value={curElem.option} key={curElem.option}>
                                                                <Box>
                                                                    <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>{curElem.option}</Typography>
                                                                    <Typography variant="body2" sx={{ fontSize: '14px', color: '#595959', fontWeight: '400', fontFamily: 'Manrope' }} color="text.secondary">
                                                                        {curElem.label}
                                                                    </Typography>
                                                                </Box>
                                                            </MenuItem>
                                                        )))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 6, md: 6, lg: 6, xl: 6 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Box sx={{ m: '0 auto 5px', width: '100%' }}>
                                            <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>Requires Approval</Typography>
                                            <FormControl fullWidth>
                                                <Select
                                                    sx={dropDownCssLabel}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={scheduleDropDownApprovals}
                                                    onChange={(e => setScheduleDropDownApprovals(e.target.value))}
                                                    displayEmpty
                                                    renderValue={(selected => {
                                                        if (!selected) {
                                                            return <Typography sx={{ color: '#9e9e9e' }}>Select Requires Approval </Typography>;
                                                        }
                                                        return <Typography sx={{ fontSize: '14px', fontWeight: '500' }}>{selected}</Typography>;
                                                    })}
                                                >
                                                    {
                                                        requireApprovals.map((curElem => (
                                                            <MenuItem value={curElem.option}>
                                                                <Box>
                                                                    <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>{curElem.option}</Typography>
                                                                    <Typography variant="body2" sx={{ fontSize: '14px', color: '#595959', fontWeight: '400', fontFamily: 'Manrope' }} color="text.secondary">
                                                                        {curElem.label}
                                                                    </Typography>
                                                                </Box>
                                                            </MenuItem>
                                                        )))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 6, md: 6, lg: 6, xl: 6 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Box sx={{ m: '0 auto 5px', width: '100%' }}>
                                            <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>Balance Rolls Over Annually</Typography>
                                            <FormControl fullWidth>
                                                <Select
                                                    sx={dropDownCssLabel}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={scheduleDropDownRoolsAnnual}
                                                    onChange={(e => setScheduleDropDownRoolsAnnual(e.target.value))}
                                                    displayEmpty
                                                    renderValue={(select => {
                                                        if (!select) {
                                                            return <Typography sx={{ color: '#9e9e9e' }}>Select Balance Annually</Typography>;
                                                        }
                                                        return <Typography sx={{ fontSize: '14px', fontWeight: '500' }}>{select}</Typography>;
                                                    })}
                                                >
                                                    {
                                                        annuallyBalance.map((curElem => (
                                                            <MenuItem value={curElem.option}>
                                                                <Box>
                                                                    <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>{curElem.option}</Typography>
                                                                    <Typography variant="body2" sx={{ fontSize: '14px', color: '#595959', fontWeight: '400', fontFamily: 'Manrope' }} color="text.secondary">
                                                                        {curElem.label}
                                                                    </Typography>
                                                                </Box>
                                                            </MenuItem>
                                                        )))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 6, md: 6, lg: 6, xl: 6 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Box sx={{ m: '0 auto 5px', width: '100%' }}>
                                            <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>Paid or unpaid</Typography>
                                            <FormControl fullWidth>
                                                <Select
                                                    sx={dropDownCssLabel}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={scheduleDropDownPaid}
                                                    onChange={(e => setScheduleDropDownPaid(e.target.value))}
                                                    displayEmpty
                                                    renderValue={(select) => {
                                                        if (!select) {
                                                            return <Typography sx={{ color: '#9e9e9e' }}>Select Paid or Unpaid</Typography>;
                                                        }
                                                        return <Typography sx={{ fontSize: '14px', fontWeight: '500' }}>{select}</Typography>;
                                                    }}
                                                >
                                                    {
                                                        paidUnpaidData.map((curElem => (
                                                            <MenuItem value={curElem.option}>
                                                                <Box>
                                                                    <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>{curElem.option}</Typography>
                                                                    <Typography variant="body2" sx={{ fontSize: '14px', color: '#595959', fontWeight: '400', fontFamily: 'Manrope' }} color="text.secondary">
                                                                        {curElem.label}
                                                                    </Typography>
                                                                </Box>
                                                            </MenuItem>
                                                        )))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box>
                            <Box sx={{ m: '0 auto 0px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <Box>
                                    <PersonOutlineOutlinedIcon sx={{ color: '#0076FE' }} />
                                </Box>
                                <Box sx={{ marginTop: '4px' }}>
                                    <Typography sx={{ color: '#0076FE', fontSize: '15px', fontWeight: '600' }}>
                                        Assign Members
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ margin: '10px 0' }}>
                                <Typography sx={{ color: '#1A1F36', fontSize: '15px', fontWeight: '500' }}>
                                    Choose how you want to assign members to the time off policy
                                </Typography>
                            </Box>
                            <Grid container spacing={1}>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope', marginBottom: '4px' }}>Add Members Through</Typography>
                                        <TeamSelectDroupDown placeholder='Select how to add members'
                                            selectedTeamsAll={selectedTeamsAll}
                                            setSelectedTeamsAll={setSelectedTeamsAll}
                                        />
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope', marginBottom: '4px' }}>Members</Typography>
                                        <MultiClientSelect label="Select Team Members" options={users} selectedValues={selectedUsers} onChange={setSelectedUsers} />
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box display="flex" alignItems="center" sx={{ gap: '5px', margin: '8px auto 4px' }}>
                                        <CheckBoxSec projects={[{ name: true }]} />
                                        <Box>
                                            <Typography sx={{ fontSize: '15px', fontWeight: '400', color: '#64748B', fontFamily: 'Manrope' }}>Automatically add all new members to this policy</Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>

                    </Box>



                    {/* End Body sec  */}

                    {/* start Footer sec  */}
                    <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                        <Button onClick={handleClosePolicyPop} variant="outlined" className='bg-white text-capitalize' color="#1A1F36" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                            Cancel
                        </Button>
                        <Box display="flex" alignItems="center" sx={{ gap: '14px' }}>
                            <Button variant="contained" color="primary" className='text-capitalize' sx={{ boxShadow: 'unset', backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily: 'Manrope' }}>
                                Save
                            </Button>
                        </Box>
                    </Box>
                    {/* End Footer sec  */}
                </Box>
            </Modal>
        </>
    )
}

export default PolicyPopup